module.exports = __webpack_public_path__ + "static/logo-classic-771d4eefbd8158f67ca05ef010a0d078.png";